import { gql, useQuery } from '@apollo/client';
import React from 'react';
import type {
  EmbedPostContentQuery,
  EmbedPostContentQueryVariables,
} from '../../graphql/generated/graphqlTypes';
import PostPreviewQuillComponent from '../../post/PostPreviewQuillComponent';
import { parsePostMentionId } from '../utils/matchMention';
import styles from './EmbedPostContent.module.scss';

const EMBED_POST_CONTENT_QUERY = gql`
  query embedPostContent($id: ID!) {
    post(id: $id) {
      id
      title
      content
      version
    }
  }
`;

interface EmbedPostContentProps {
  id: string;
}

const EmbedPostContent = ({ id }: EmbedPostContentProps) => {
  const { id: postId, anchor } = parsePostMentionId(id);

  const { data } = useQuery<
    EmbedPostContentQuery,
    EmbedPostContentQueryVariables
  >(EMBED_POST_CONTENT_QUERY, { variables: { id: postId } });

  const content = data?.post.content;
  return (
    <div className={styles.container}>
      {content && (
        <PostPreviewQuillComponent
          autoHeight
          content={content}
          anchor={anchor}
        />
      )}
    </div>
  );
};

export default EmbedPostContent;
